export default {
  root: ({ props }) => ({
    class: [
      'inline-block relative',
      'w-8 h-4',
      'rounded-xl',
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled
      }
    ]
  }),
  slider: ({ props }) => ({
    class: [
      // Position
      'absolute top-0 left-0 right-0 bottom-0',
      { 'before:transform before:translate-x-3': props.modelValue == props.trueValue },

      // Shape
      'rounded-xl',

      // Before (slider handle):
      'before:absolute before:top-1/2 before:left-0.5',
      'before:-mt-1.5',
      'before:h-3 before:w-3 before:bg-white',
      'before:rounded-full',
      'before:duration-200',
      'before:bg-neutral-0 before:dark:bg-neutral-900',

      // Colors
      'border',
      {
        'bg-neutral-200 dark:bg-neutral-700': !(props.modelValue == props.trueValue),
        'bg-green-500 dark:bg-green-400': props.modelValue == props.trueValue
      },

      { 'border-transparent': !props.invalid },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'peer-hover:bg-neutral-300 dark:peer-hover:bg-neutral-600 ':
          !(props.modelValue == props.trueValue) && !props.disabled
      },
      {
        'peer-hover:bg-green-600 dark:peer-hover:bg-neutral-300 ':
          props.modelValue == props.trueValue && !props.disabled
      },
      'peer-focus-visible:ring peer-focus-visible:ring-green-400/50 dark:peer-focus-visible:ring-green-300/50',

      // Transition
      'transition-colors duration-200',

      // Misc
      'cursor-pointer'
    ]
  }),
  input: {
    class: [
      'peer',

      // Size
      'w-full',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-[1.5rem]',
      'outline-none',

      // Misc
      'appearance-none',
      'cursor-pointer'
    ]
  }
}
